import { toast } from 'react-toastify';
import { tryParseErrorStatus } from '../utils/clientErrors';

export const GENERIC_ERROR_MESSAGE =
  'Unexpected error.  Please try again later or contact site administrators if the problem persists.';

export const handleErrorToasts = (errorMessage?: string) => {
  if (!errorMessage) return;
  const status = tryParseErrorStatus(errorMessage);
  if (!status) return console.warn(errorMessage);
  console.warn('Error:', status);
  const { status_code, status_id, status_text } = status;
  if (status_code === 400) return;

  if (status_code === 404 && status_text === 'IIOT_No dealer to redirect') {
    return toast.error(
      `Error: A PowerManage host with that name could not be found.`,
      { autoClose: false },
    );
  }
  return toast.error(
    `Unexpected error: ${status_code} - ${status_text} ${status_id ? `(Ref. ID: ${status_id})` : ''}`,
    { autoClose: false },
  );
};

export const parseErrorResponse = (errorMessage?: string) => {
  if (!errorMessage) return undefined;
  const errorStatus = tryParseErrorStatus(errorMessage);
  if (errorStatus?.status_code === 400) return errorStatus.status_text;
  return GENERIC_ERROR_MESSAGE;
};
